<template>
	<div class="exh">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>在线展厅</span>
			<div></div>
			<!--      <div class="nav-right">
		  <van-icon name="location-o" size="1rem" />
		  <span>西安</span>
		  <van-icon name="arrow-down" />
		</div> -->
		</div>
		<!-- 招标菜单 -->
		<van-tabs v-model="active" class='menu' @click="changes">
			<van-tab title="设计案例" name="1"></van-tab>
			<van-tab title="线下展厅" name="2"></van-tab>
			<div class="tips">
				<div>功能模块正在开发中，敬请期待~</div>
				<van-button color="#f1452f" size="mini" round to="/Home">去逛逛</van-button>
			</div>
		</van-tabs>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				active: 0,
				value: '',
			}
		},
		methods: {
			changes(name) {}
		}
	}
</script>

<style scoped>
	.exh {
		background: #f2f2f2;
		height: 100%;
		padding-top: 2rem;
	}

	.exh .nav .nav-right,
	.exh .nav .nav-left {
		display: flex;
		align-items: center;
	}

	.exh .nav .nav-right i {
		height: 100%;
	}

	.exh .nav .nav-right span {
		margin: 0 0.2rem;
	}

	.exh .menu .van-search {
		margin-bottom: 1rem;
	}

	.exh .menu .van-cell {
		text-align: left;
	}

	.exh .menu .van-cell .van-cell__title {
		font-size: 0.8rem;
		color: #232323;
	}

	.exh .menu .van-cell .menu_label {
		font-size: 0.8rem;
		display: flex;
		align-items: center;
	}

	.exh .menu .van-cell .menu_label .van-icon {
		margin-right: 0.5rem;
	}

	.exh .menu .van-cell .menu_label .van-tag {
		margin-left: 1rem;
		height: 0.85rem;
	}

	.exh .tips {
		margin-top: 2.5rem;
		text-align: center;
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.exh .tips div {
		color: #B2B2B2;
		font-size: 0.8rem;
	}

	.exh .tips button {
		padding: 0 1rem;
		margin-top: 0.5rem;
	}
</style>



// WEBPACK FOOTER //
// src/components/home/exhibition.vue